import { ButtonContainer, Divider, InfoCard } from "@/components";
import { InfoCards, InforContainer, TicketsTable, TicketsTableRow, TicketLink, EmptyTickets, TicketsTitle } from "./style";
import { useInformacoes } from "./useInformacoes";

export function Informacoes() {
  const { order, childTickets, loadingTickets, documents, conversation } = useInformacoes();

  return (
    <InforContainer>
      <InfoCards>
        <InfoCard
          title="Informações do pedido"
          labels={[
            "Order ID",
            "Transportadora",
            "Tipo de pagamentos",
            "Sequence",
            "Data",
          ]}
          values={[
            order?.orderId,
            order?.shippingData.logisticsInfo[0].deliveryIds[0].courierName,
            order?.paymentData.transactions[0].payments[0].paymentSystemName,
            order?.sequence,
            order?.creationDate
              ? new Date(order.creationDate).toLocaleDateString("pt-BR")
              : "",
          ]}
        />
        <InfoCard
          title="Cliente"
          labels={["Nome", "Telefone", "CPF", "E-mail"]}
          values={[
            `${order?.clientProfileData.firstName ?? ""} ${order?.clientProfileData.lastName ?? ""}`.trim(),
            order?.clientProfileData.phone,
            order?.clientProfileData.document,
            documents.map((doc) => doc.email).find((e) => !!e)||  conversation[0]?.to[0].email || order?.clientProfileData.email || "",
          ]}
        />
      </InfoCards>

      <Divider />

      <TicketsTitle>Tickets sobre o pedido</TicketsTitle>

      {loadingTickets ? (
        <EmptyTickets>Carregando tickets...</EmptyTickets>
      ) : childTickets.length === 0 ? (
        <EmptyTickets>Não existem tickets associados a este pedido</EmptyTickets>
      ) : (
        <TicketsTable>
          <TicketsTableRow $header>
            <span>Ticket</span>
            <span>Ação</span>
          </TicketsTableRow>
          {childTickets.map((ticket) => (
            <TicketsTableRow key={ticket.id}>
              <span>#{ticket.id}</span>
              <TicketLink
                href={`https://bcrcx-86621.zendesk.com/agent/tickets/${ticket.id}`}
                target="_blank"
                rel="noreferrer"
              >
                Ver mais
              </TicketLink>
            </TicketsTableRow>
          ))}
        </TicketsTable>
      )}

      <ButtonContainer />
    </InforContainer>
  );
}